import axios from 'axios';
import apiUrlOne from '../../utils.js/Config';


export const getDashboardStats = async (startDate, endDate) => {
    try {
        const token = localStorage.getItem('accessToken');
        const params = new URLSearchParams();
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        const queryString = params.toString() ? `?${params.toString()}` : '';
        const response = await axios.get(`${apiUrlOne}/dashboard/stats${queryString}`, {
            headers: {
                'accept': 'application/json',
                ...(token && { 'Authorization': `Bearer ${token}` })
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching dashboard stats:", error);
        throw error;
    }
};

export const exportDashboardExcel = async (startDate, endDate) => {
    try {
        const token = localStorage.getItem('accessToken');
        const params = new URLSearchParams();
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);

        const queryString = params.toString() ? `?${params.toString()}` : '';
        const response = await axios.get(`${apiUrlOne}/dashboard/export-excel${queryString}`, {
            responseType: 'blob',
            headers: {
                ...(token && { 'Authorization': `Bearer ${token}` })
            }
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Dashboard_Report_${startDate || 'all'}_to_${endDate || 'all'}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error exporting dashboard excel:", error);
        throw error;
    }
};